<template>
    <div class="row no-gutters ml-3 mr-3">
        <div class="col-12">
            <div class="input-group mb-3" >
                <div class="input-group-prepend " >
                    <span class="input-group-text img-input-group">
                        <img :src="searchimg" class="imgborder" alt="searchimg" /> 
                    </span>
                </div>
                <!-- ENTER SEARCH TEXT -->
                <input
                class="form-control input-border"
                type="text"  
                placeholder="Search People"  id="searchedInput" autocomplete="off"
                aria-label="Search" v-model="searchText"   
                />
            </div>
            <div class="col-12 myvideosection d-flex justify-content-lg-start justify-content-md-start justify-content-sm-start p-2 pb-3">
                <span
                    class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                    id="c_suite"
                    :class="{'activeVideoSub':member_type == 'c_suite'}"
                    @click="getCompanyOfficials('c_suite')">C-Suite members
                </span>
                <span
                    class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"                
                    id="advisor"
                    :class="{'activeVideoSub':member_type == 'advisor'}"
                    @click="getCompanyOfficials('advisor')">Advisors
                </span>
                <span
                    class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                    id="founder"
                    :class="{'activeVideoSub':member_type == 'founder'}"
                    @click="getCompanyOfficials('founder')">Founders
                </span>
                <span
                    class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                    id="team"
                    :class="{'activeVideoSub':member_type == 'team'}"
                    @click="getCompanyOfficials('team')">Team
                </span>
            </div>
      
            <div class="col-12 pb-5 mb-4" v-if="pageLoader">
                <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
            </div>
            <div v-else>
            <div class="row no-gutters mt-2 pb-5"  v-if="membersList!== null && membersList.length>0">
                <img src="../../assets/play_video.svg" id="playvideobtn" v-if="!testplaybtn" alt="playvideo" class="d-none"  >
              <img src="../../assets/Pausevideo.svg" v-if="testplaybtn" id="playvideobtn" class="d-none" alt="pausevideo"   >
                <div  v-for="(item,index) in filteredList"  :key="index" class="col-md-6 ">
                    <div class="shadow card ml-2 mr-2 mb-2 p-2 pl-3 pr-3 overlay-gradient">
                        <!-- <div>
                            <video height="280" controlsList="nodownload"  id="profilevideo" :poster="item.profileVideoThumbNail" :ref="'video' + item.profileId" >
                                <source :src="item.profilevideoLink">
                            </video>
                        </div>
                        <div class="card-img-overlay ">
                                        <div class="row mb-3 ml-0 mr-0 p-lg-3 p-md-3 p-2" :class="{'black_overlay1': item.profilevideoLink}"> -->
                        <div class="">
                            <div class="row d-flex justify-content-between ml-0 mr-0">
                                            <div class="pl-0 pr-0 ml-0 d-flex ">
                                                <!-- <img v-if="!item.profilePictureLink" @click="selectedUser(item.userId)" class="img-fluid rounded-circle hover pointer" id="profImage" src="../../assets/Profile_placehlder.svg" /> -->
                                                <div v-if="!item.profilePictureLink" id="profImage" class=" text-center pointer rounded-circle white" :class="item.firstName.charAt(0)" @click="selectedUser(item.aliasLink)">
                                                    <span class="white fontsize16 defmargintop text-uppercase">{{item.firstName.charAt(0)}}</span>
                                                </div>
                                                <img v-else :src="item.profilePictureLink" alt="profilepic" @click="selectedUser(item.aliasLink)" @error="item.profilePictureLink = null" class="img-fluid rounded-circle hover loadingBgImg pointer" id="profImage">
                                            </div>
                                            <div class="d-flex flex-column p-1 proximanova fontsize12 smalldevfont1" >
                                                    <div class="my-auto" v-if="item.followingFlag === 'N'">
                                                        <div>
                                                            <button :disabled="item.disablefollowBtn" @click="followUser(item.profileId,index, item)" class="bordernone btn button-create proximanova fontsize13 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white" >                                         
                                                                Follow 
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="my-auto" v-if="item.followingFlag === 'Y'">
                                                        <div >
                                                            <button :disabled="item.disablefollowBtn" @click="UnfollowUser(item.profileId,index, item)" class="bordernone btn button-create proximanova fontsize13 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white">                                         
                                                                Following 
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                        <div class="col-12 pl-0 pr-0 d-flex flex-column mt-2">
                                            <div class="d-flex">
                                            <div class="proximanova-semibold mt-1 fontsize14 black text-capitalize hover pointer" id="nameBlock" @click="selectedUser(item.aliasLink)">{{item.firstName}} {{item.lastName}}</div>
                                            <div class=""><img src="../../assets/verify_blue.svg" class="my-auto ml-1" alt="verify" width="16px" height="16px" title="Verified" v-if="item.verifiedProfile == 'SUCCESS'"> </div>
                                            </div>
                                            <div class="fontsize12 black60 proximanova text-capitalize pointer" id="nameBlock" @click="selectedUser(item.aliasLink)">@{{item.aliasLink}}</div>
                                                <div class="proximanova fontsize12 black60 flex-nowrap text-capitalize mt-1">
                                                <div v-if="item.designation">{{item.designation}}</div>                                                
                                            </div>
                                            <div class="d-flex proximanova fontsize12 black60  text-capitalize flex-wrap">
                                                <div v-if="item.company">{{item.company}}</div>  
                                                <div v-if="item.city">, {{item.city}}</div>                                                
                                                <div v-if="item.country">, {{item.country}}</div>                                              
                                            </div>  
                                        </div>
                                        <!-- <div class="text-center mt-3" v-if="item.profilevideoLink ">
                                            <img src="../../assets/play_video.svg" class="peopleplaypausevideobtn"  v-if="!item.isPlaying " alt="playvideo" @click="play_suggested('video'+item.profileId,index, item)" >
                                            <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="item.isPlaying && item.replayVideo">
                                                <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayfollowerVideo('video'+item.profileId,index, item)">
                                            </div>
                                            <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="item.isPlaying && item.loadingVideo">
                                                <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                                            </div>
                                            <img src="../../assets/Pausevideo.svg" class="peopleplaypausevideobtn mx-auto pausebtn" :class="{'display-button': item.isPlaying}" v-if="item.isPlaying && !item.replayVideo && !item.loadingVideo" alt="pausevideo" @click="play_suggested('video'+item.profileId,index, item)" >                                
                                        </div>
                                        <div class="text-center mt-4 novidstyles" v-else>
                                            <img src="../../assets/No_profile_video.svg" width="50px" height="50px" title="No profile video" class="" alt="playvideo" >
                                        </div>
                                        <div id="bottom">                                                
                                            <div class="row d-flex flex-column ml-0 mr-0 justify-content-between p-lg-3 p-md-3 p-2" :class="{'black_overlay2': item.profilevideoLink}">
                                                <div class="d-flex flex-wrap badgesection mt-2" v-if="item.userBadges && item.userBadges.length>0">
                                                    <span  v-for="(badge, index) in item.userBadges" :key="index">
                                                        <span class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize10 proximanova" :class="{'white borderwhite':item.profilevideoLink}" v-if="index < 2">
                                                        {{badge.badgeIn}}
                                                        </span>
                                                        <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize10 proximanova-semibold" :class="{'backgroundcolorwhite borderwhite':item.profilevideoLink}" v-if="index > 1 && index == 2" @click="selectedUser(item.aliasLink)">
                                                        + {{item.userBadges.length - 2}}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div class="row d-flex ml-0 mr-0 justify-content-between">
                                                <div class="d-flex flex-column  mb-2  justify-content-between">
                                                    <span :class="{'proximanova-semibold fontsize16':item.profilevideoLink}"  class="proximanova fontsize12 smalldevfont1 text-capitalize ml-lg-2 ml-1" v-show="item.followersCount > 0" >Followers </span>                                                        
                                                    <div class="row mt-2 ml-0 d-flex ml-2"  >
                                                        <div  v-for="(item1,index1) in item.followersProfilePicture" :key="index1" class="d-flex">
                                                            <div v-show="index1 < 6" class="">
                                                                <img v-if="!item1.profilePictureLink"  id="followImage" alt="profilepic" class="img-fluid rounded-circle" @click="selectedUser(item1.aliasLink)" src="../../assets/Profile_placehlder.svg" />
                                                                <img v-else :src="item1.profilePictureLink" alt="profilepic" @click="selectedUser(item1.aliasLink)" class="img-fluid rounded-circle  loadingBgImg" id="followImage">                                                                        
                                                            </div>     
                                                            <div v-if="index1 > 5 && item.remFollowers !== 0">
                                                                <span class="badge badge-pill badge-success ml-2 badge">+{{item.remFollowers}}</span>
                                                            </div>                                                  
                                                        </div>
                                                    </div>                                                           
                                                </div>
                                                <div class="d-flex flex-column p-1 mt-4 proximanova fontsize12 smalldevfont1" >
                                                    <div  :class="{'padding-follow' :item.followersCount === 0}" v-if="item.followingFlag === 'N'">
                                                        <div id="follow">
                                                            <button :disabled="item.disablefollowBtn" @click="followUser(item.profileId,index, item)" :class="{'proximanova-semibold fontsize16':item.profilevideoLink }" class="bordernone backgroundnone borderradius20 proximanova-semibold fontsize16 black80 hover" >                                         
                                                                Follow 
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div   v-if="item.followingFlag === 'Y'">
                                                        <div >
                                                            <button :disabled="item.disablefollowBtn" id="followinguser" @click="UnfollowUser(item.profileId,index, item)" :class="{'proximanova-semibold fontsize16':item.profilevideoLink}" class="bordernone backgroundnone borderradius20 proximanova-semibold fontsize16 white hover">                                         
                                                                UnFollow 
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div> 
                                                </div> 
                                            </div>  
                                        </div>                                                 -->
                                    </div>
                    </div>
                </div>
            
            </div>
            <div v-else class="pb-5">
                <no-records-found :message="noRecordsMessage"></no-records-found>
            </div>
            </div>
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
    </div>
    
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import NoRecordsFound from '../../components/NoRecordsFound.vue'
import APIerrorModal from '../../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
import router from '../../router.js'
export default{
    data(){
        return{
            companyprofileId: null,
            noRecordsMessage : "No Records Found",
            searchimg: require('../../assets/Search.svg'),
            searchText: '',
            limit: 15,
            offset: 0,
            member_type: 'c_suite',
            membersList: [],
            pageLoader: true,   
            isScrolled: false  ,
            noResults: false,
            testplaybtn : false,
            //total duration of viewd video
            currentUserProfileId: null,
            totalVidSec : null,
            displayAPIerrorModal : false,
        }
    },
    components : {
      NoRecordsFound,
      APIerrorModal
    },
    computed:{
        filteredList(){
            return this.membersList.filter(member => {
                return member.firstName.toLowerCase().includes(this.searchText.toLowerCase())
            });
        },

    },
    methods:{    
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        //Nav to selected user screen after clicking on any user name
        selectedUser(id){
            this.$store.state.selectedUser = id;   
            // if(sessionUtils.getUserId() === id){
            // router.push({
            //     name : 'welcome'
            // })
            // }else{
            this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
            // }       
            //this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});  
        },   
        // get company officials record based on roles    
        getCompanyOfficials(type){
            if(type !== this.member_type){
                console.log(type,this.member_type)
                this.member_type = type;
                this.pageLoader = true;
            }
            // console.log(type,this.member_type)
            // this.member_type = type;
            this.membersList = []
            httpuserprofile.get('/userprofile/getCompanyOfficialsListByUsingRoleName?companyProfileId='+this.companyprofileId+'&searchText='+this.member_type+'&limit='+this.limit+'&offset='+this.offset+"&type=user&followerProfileId="+this.currentUserProfileId)
            .then(response => { 
                console.log(response)
                console.log(response.data.length)
                if(response.data && response.data.length > 0){
                    response.data[0].list.forEach(function(d){
                        d.isPlaying = false; 
                        d.replayVideo = false;
                        d.loadingVideo = false;    
                        d.disablefollowBtn = false;         
                    })
                    this.membersList = response.data[0].list;
                    this.pageLoader = false             ;
                    console.log(this.membersList)       
                }else{
                    this.noResults = true;
                    this.pageLoader = false      
                }
                this.isScrolled = false;
                this.pageLoader = false 
            }).catch((e) => {
                console.log(e);
                this.pageLoader = false
                this.isScrolled = false
             });
            
        }, 
        //follow user
        followUser(profId,i, user){
            this.isScrolled = true;  
            user.disablefollowBtn = true;
            httpuserprofile
                .post("/userprofile/saveFollowing?profileId="+this.currentUserProfileId+"&followingId="+profId)
                .then(response => {
                this.membersList[i].followingFlag = 'Y'; 
                user.disablefollowBtn = false;
               // this.getFollowersListFollowers(profId,i);
                this.isScrolled = false;          
            }).catch((e) => {
            console.log(e)
            user.disablefollowBtn = false;
            this.displayAPIerrorModal = true;
            })       
        },
        //unfollow user
        UnfollowUser(profId,i, user){    
            this.isScrolled = true; 
            user.disablefollowBtn = true;
            httpuserprofile
                .delete("/userprofile/unfollow?profileId="+this.currentUserProfileId+"&followingId="+profId)
                .then(response => {   
                this.membersList[i].followingFlag = 'N'; 
                user.disablefollowBtn = false;       
                  //  this.getFollowersListFollowers(profId,i);
            }).catch((e) => {
            console.log(e)
            user.disablefollowBtn = false;
            this.displayAPIerrorModal = true;
            })
        },
        // play profile video of user
        play_suggested(test,ind, videoItem) { 
            var that = this;
            this.testplaybtn = !this.testplaybtn           
            let index = test.substr(5)
            if(!this.membersList[ind].isPlaying){
                for(var i=0 ;i <this.membersList.length; i++){
                    if(i === ind){                 
                        this.membersList[ind].isPlaying = true;
                        this.$refs[test][0].play();
                    }else{  
                        if(!this.membersList[i].replayVideo)  {                 
                        this.$refs['video'+this.membersList[i].profileId][0].pause();     
                        this.membersList[i].isPlaying = false;     
                        }        
                    } 
                    this.totalVidSec = this.$refs[test][0].duration;
                    this.totalVidSec = Math.round(this.totalVidSec)
                    this.$refs[test][0].onended = videoEnded;       
                    this.$refs[test][0].oncanplay = stopLoadingLogo;  
                    this.$refs[test][0].onwaiting = displayLoadingLogo;           
                }        
            }else{
                this.membersList[ind].isPlaying = false;
                this.$refs[test][0].pause();       
                let percent = this.$refs[test][0].currentTime;
                percent = Math.round(percent)
                this.viewVideo(videoItem, percent) 
            }   
            function videoEnded() {
                that.totalVidSec = that.$refs[test][0].duration;
                that.totalVidSec = Math.round(that.totalVidSec)
                that.membersList[ind].isPlaying = true;
                that.membersList[ind].replayVideo = true;
                that.membersList[ind].loadingVideo = false;
                let percent = that.totalVidSec;
                percent = Math.round(percent)
                that.viewVideo(videoItem, percent)
            }
            function stopLoadingLogo() {
                that.totalVidSec = that.$refs[test][0].duration;
                that.totalVidSec = Math.round(that.totalVidSec)
                // console.log("stop loading")
                if(that.membersList[ind].isPlaying){
                    that.membersList[ind].loadingVideo = false;
                }
            }
            function displayLoadingLogo() {
                // console.log("start loading")
                if(that.membersList[ind].isPlaying){
                    that.membersList[ind].loadingVideo = true;
                }
            } 
        },
        replayfollowerVideo(test,ind, videoItem) {
            // console.log("replay video")
            this.membersList[ind].replayVideo = false;
            this.membersList[ind].isPlaying = false;
            this.play_suggested(test,ind, videoItem)
        },
        //this will invoke after play/pause to maintain view records to the particular video
        viewVideo(videoItem, viewdsec){
            var fd = new FormData(); 
            var obj = {
                profileId : this.currentUserProfileId,
                videoId: videoItem.profilevideoid,
                videoProfileId: videoItem.profileId,
                viewed_sec : viewdsec,
                video_type : 'PROFILEVIDEO'
            }
            console.log("view obj : ", obj)
            var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
            fd.append("userVideoViews", blob)
            fd.append("duration", this.totalVidSec)
            httpuserprofile.post("/userprofile/viewVideo", fd, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Accept" : "*/*"
                }
            })
            .then(response => {
                console.log(response)                          
            }) .catch((e) => {
                console.log(e)
            })
        },   
        handlePageScroll () {  
        // console.log('enter')      
            if(!this.isScrolled){               
                if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.noResults && !this.showdropdown ) {            
                    this.isScrolled = true;    
                    this.offset = this.offset+15; 
                    this.getCompanyOfficials(this.member_type);         
                }        
            }    
        },    
    },
    mounted(){
        this.currentUserProfileId = sessionUtils.getUserProfileId();
        this.companyprofileId = this.$session.get("company_profile_id")
        console.log(this.companyprofileId)
        this.getCompanyOfficials(this.member_type);
        window.addEventListener('scroll', this.handleScroll);
    }

}
</script>
<style scoped>
.peopleCard:nth-child(odd) {
  margin-right: 5px !important;
}
.card-img-overlay {
    padding: 0 !important;
}
.card-img-overlay:hover #playvideobtn{
    display: block;
}
.peopleplaypausevideobtn{
  /* margin-left: 1%; */
  margin-top: 5%;
  cursor: pointer;
}
.pausebtn{
  display: none;
}
.card:hover .pausebtn{
  display: block !important;
  /* margin-left: 45%; */
  margin-top: 9.5%;
}
.form-control {
  background-color: rgb(161, 166, 179,0.1) !important;
  border: 0px solid #ced4da !important;
  /* border-radius: 0px 10px 10px 0px !important; */
}
.black_overlay1 {
  background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
  border-radius: 4px 4px 5px 4px;
}
.black_overlay2 {
  background: linear-gradient(180deg, rgba(0,0,0,0) 10%, #000000 100%);
  border-radius: 0 4px 5px 4px;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.loadingBgImg1{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 25px 25px;
}
.card-padding{
    padding-right: 0px !important;
}
#profilevideo{
    width: 100%;
    border-radius: 4%; 
    object-fit: fill;
}
.input-border{
  border-radius: 0px 10px 10px 0px !important;
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}
.imgborder {
	padding: 11px 15px 10px 20px;
	background-color: rgb(161, 166, 179,0.1);
	border-radius: 10px 0px 0px 10px;
  }
  .imgborder-search {
	padding: 11px 15px 11px 10px;
	background-color: rgba(161, 166, 179,0.1);
	border-radius: 0px 10px 10px 0px;
  }
.pageloader{
  width: 10%;
  margin-left: 45%;
  margin-top: 5%;
}
#nameBlock:hover{
    color:#007AFF !important;
}
.font12-60opacity{
	font-size: 12px;
	color: rgba(31,31,31,.6);
	font-family: 'Proxima Nova Regular';
}
#profImage{
    width: 45px;
    height: 45px;
    line-height: 42px;
    border:1px solid #ced4da;
}
#profImage:hover{
    border: 1px solid #007AFF;
}
.card-img-overlay {
    padding: 0 !important;
}
.card-img-overlay:hover #playvideobtn{
    display: block;
}
.input-group-prepend{
  margin-right: 0 !important;
}
.input-group-text {
  padding: 0px 0px 0px 0px !important;
}
#playvideobtn {
    display: block;
    margin-left: 45%;
    margin-top: 11% !important;
    margin-bottom: 5%;
    cursor: pointer;
}
.card{
    border: 1px solid #dddfe5;
    border-radius: 10px;
    background-color: #fff;
}
.text-color1{
    color: #FFFFFF !important;
    font-size: 14px  !important;
}
.text-color2{
    color: #FFFFFF !important;
    font-size: 12px  !important;
}
#bottom {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
}
.font12-reg{
	/* color: rgba(52, 73, 94, 0.8); */
	font-family: 'Proxima Nova Regular';
	/* font-weight: bold; */
	font-size: 12px;
}
#followinguser{
  transition : 0.5s all ease;
  position : relative;
  background-color: #007AFF !important;        
  border-radius: 4px;
  padding-bottom: 5px;    
  padding-right: 10px !important;
  padding-top: 5px !important;
  padding-left: 10px !important;
  z-index : 1;
  text-align: right;
}
#followinguser::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 50%;
  right : 50%;
  bottom : 0;
  opacity : 0;
  content : "";
  border-radius:20px;
  background-color :  rgba(255,255,255,.3);
}
#followinguser:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  padding-left:5px;
  opacity : 1;
  z-index : -1;
  padding-bottom: 5px;    
  padding-right: 10px !important;
  padding-top: 5px !important;
  border-radius:20px;
}
#followinguser a{
  margin-left:5px;
  color: #FFF !important;
  cursor: pointer;
}
#follow{
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1;
  text-align: right;
  /* right:2%; */
  padding-left : 5px;
  padding-top: 2px;
  padding-right: 5px;
  padding-bottom: 2px;
}
#follow::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 10%;
  bottom : 0;
  opacity : 0;
  content : "";
  border-radius:20px;
  background-color :  rgba(31,31,31,.3);
}
#follow:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  padding-left:5px;
  opacity : 1;
  z-index : -1;
  border-radius:20px;
}
#followImage{
    width: 30px;
    height: 30px;
    transform: scale(1.2)  !important;
    border: 1px solid #1F1F1F;
    cursor: pointer;
}
#followImage:hover{
    border: 1px solid #0078ff;
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
@media screen and (max-width:560px) {
    /* #profImage{
        width: 30px;
        height: 30px;
        line-height: 22px;
        border:1px solid #ced4da;
    } */
    .fontsize12{
        font-size: 13px !important;
    }
}
</style>
